module.exports = __webpack_public_path__ + "img/yishi11.6b7c6320.jpg";